import { useMemo } from 'react';

import { useMerchant } from '@contexts/operator/MerchantContext';

import operatorApiFetch from '@services/operator/apiService';

/**
 * Operator Supplier Service Hook
 *
 * 從 MerchantContext 取得 merchantId 並注入到相關 API 呼叫中
 *
 * @param {Object} [options]
 * @param {string} [options.merchantId] - 可選，未提供則從 MerchantContext 獲取
 */
export function useOperatorSupplierService(options = {}) {
  const merchantContext = useMerchant();
  const contextMerchantId = merchantContext?.merchantId;
  const merchantId = options.merchantId ?? contextMerchantId;

  return useMemo(() => ({
    getRecords: async (params = {}) => {
      const res = await operatorApiFetch('suppliers/get_records', {
        method: 'POST',
        body: {
          ...params,
          merchant_id: merchantId
        }
      });
      return res.json();
    },

    getIds: async (params = {}) => {
      const res = await operatorApiFetch('suppliers/get_ids', {
        method: 'POST',
        body: {
          ...params,
          merchant_id: merchantId
        }
      });
      return res.json();
    },

    get: async (id) => {
      const res = await operatorApiFetch(`suppliers/${id}`, { method: 'GET' });
      return res.json();
    },

    create: async (data) => {
      const res = await operatorApiFetch('suppliers', {
        method: 'POST',
        body: {
          supplier: {
            merchant_id: merchantId,
            ...data,
          }
        }
      });
      return res.json();
    },

    update: async (id, data) => {
      const res = await operatorApiFetch(`suppliers/${id}`, {
        method: 'PUT',
        body: { supplier: data }
      });
      return res.json();
    },

    destroy: async (id) => {
      const res = await operatorApiFetch(`suppliers/${id}`, { method: 'DELETE' });
      return res.json();
    },
  }), [merchantId]);
}
